import { render, staticRenderFns } from "./LabSettlement.vue?vue&type=template&id=7960bd26&scoped=true&"
import script from "./LabSettlement.vue?vue&type=script&lang=js&"
export * from "./LabSettlement.vue?vue&type=script&lang=js&"
import style0 from "./LabSettlement.vue?vue&type=style&index=0&id=7960bd26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960bd26",
  null
  
)

export default component.exports